import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface selectedMenuId {
  menuId: number;
}

const initialState: selectedMenuId = {
  menuId: 0,
};

const selectedMenuId = createSlice({
  name: "selectedMenu",
  initialState,
  reducers: {
    setNumber: (state, action: PayloadAction<number>) => {
        state.menuId = action.payload;
    },
  },
});

export const { setNumber } = selectedMenuId.actions;
export default selectedMenuId.reducer;
